import { getImageUrl } from '@helpers/image';
import React from 'react';
import { NewsCardStyles as s } from './NewsCard.styles';
const NewsCard = (props) => {
    return (React.createElement(s.Container, { href: props.readMoreLink },
        React.createElement(s.ImageContainer, null,
            React.createElement(s.Image, { alt: props.altText ?? '', loading: "lazy", role: props.altText ? undefined : 'presentation', src: getImageUrl(props.imageUrl, { mode: 'crop', width: 600, heightratio: 325 / 418 }), srcSet: [
                    `${getImageUrl(props.imageUrl, {
                        mode: 'crop',
                        width: 600,
                        heightratio: 325 / 418,
                    })} 1x`,
                    `${getImageUrl(props.imageUrl, {
                        mode: 'crop',
                        width: 1200,
                        heightratio: 325 / 418,
                    })} 2x`,
                ].join(',') }),
            props.tag && (React.createElement(s.TagContainer, null,
                React.createElement(s.TagText, null, props.tag)))),
        React.createElement(s.ContentContainer, null,
            React.createElement(s.Date, null, props.date),
            React.createElement(s.Title, null, props.title),
            React.createElement(s.ReadMore, null, "Read More"))));
};
export default NewsCard;
